module.exports = __webpack_public_path__ + "ed04269804fc8deca4c8dc5ab46ca3d3.pdf";